//Generated File 
export default class DataTypes{
	static readonly ATTACHMENT = `ATTACHMENT`;
	static readonly BIGDECIMAL = `BIGDECIMAL`;
	static readonly BOOLEAN = `BOOLEAN`;
	static readonly DATE = `DATE`;
	static readonly ENTITYREFERENCE = `ENTITYREFERENCE`;
	static readonly FLATOBJECT = `FLATOBJECT`;
	static readonly FLATOBJECTLIST = `FLATOBJECTLIST`;
	static readonly GUI2FlatObject = `GUI2FlatObject`;
	static readonly GUI2List = `GUI2List`;
	static readonly GUI2WholeEntity = `GUI2WholeEntity`;
	static readonly INTEGER = `INTEGER`;
	static readonly LONG = `LONG`;
	static readonly NORMALLIST = `NORMALLIST`;
	static readonly STRING = `STRING`;
}
